const normalizeField = (value) => {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length ? trimmed : undefined;
  }

  return value;
};

export const buildPatientUpdatePayload = (formValues = {}) => {
  const payload = {
    firstName: normalizeField(formValues.firstName),
    lastName: normalizeField(formValues.lastName),
    dateOfBirth: normalizeField(formValues.dateOfBirth),
    gender: normalizeField(formValues.gender),
    phone: normalizeField(formValues.phone),
    mobile: normalizeField(formValues.mobile),
    address: normalizeField(formValues.address),
    diagnosis: Array.isArray(formValues.diagnosis) ? formValues.diagnosis.join(', ') : normalizeField(formValues.diagnosis),
    notes: normalizeField(formValues.notes),
    amka: normalizeField(formValues.amka),
    am: normalizeField(formValues.am),
    email: normalizeField(formValues.email),
    card_date: normalizeField(formValues.cardDate || formValues.card_date || formValues.datekarta),
    allergies: normalizeField(formValues.allergies),
    death: normalizeField(formValues.death),
    age: normalizeField(formValues.age),
  };

  return Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== undefined));
};

export const fetchPatients = async (apiClient, page = 1, limit = 20) => {
  const { data } = await apiClient.get('/patients', {
    params: { page, limit }
  });
  return {
    patients: data.data || data, // Handle both paginated and non-paginated responses
    pagination: data.pagination || { total: 0, page: 1, totalPages: 1 }
  };
};

export const createPatient = async (apiClient, payload) => {
  const { data } = await apiClient.post('/patients', payload);
  return data;
};

export const updatePatient = async (apiClient, id, payload) => {
  const { data } = await apiClient.put(`/patients/${id}`, payload);
  return data;
};

export const deletePatient = async (apiClient, id) => {
  await apiClient.delete(`/patients/${id}`);
};

export const importPatients = async (apiClient, file, mapping = null) => {
  const formData = new FormData();
  formData.append('file', file);
  if (mapping) {
    formData.append('mapping', JSON.stringify(mapping));
  }
  
  const { data } = await apiClient.post('/patients/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const clearAllPatients = async (apiClient) => {
  await apiClient.delete('/patients/clear-all');
};

export const exportAllPatients = async (apiClient) => {
  return await apiClient.get('/patients/export', {
    responseType: 'blob'
  });
};

export const checkDuplicates = async (apiClient, params) => {
  const { data } = await apiClient.get('/patients/check-duplicates', { params });
  return data;
};
